const API_BASE = process.env.REACT_APP_API_URL ?? '';

const AUTH_KEY = 'davetiye_admin_token';

export function getToken() {
  return localStorage.getItem(AUTH_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(AUTH_KEY, token);
  else localStorage.removeItem(AUTH_KEY);
}

async function apiFetch(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers ?? {}),
  };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `İstek başarısız (${res.status})`);
  }
  if (res.status === 204) return null;
  return res.json();
}

// ── Auth ──

export async function login(username, password) {
  const data = await apiFetch('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  });
  setToken(data.token);
  return data;
}

export async function logout() {
  try {
    await apiFetch('/api/auth/logout', { method: 'POST' });
  } catch {
    /* ignore */
  }
  setToken(null);
}

export async function getMe() {
  return apiFetch('/api/auth/me');
}

// ── Categories ──

export async function getCategories(hub) {
  return apiFetch(`/api/admin/categories?hub=${hub}`);
}

export async function createCategory(hub, payload) {
  return apiFetch('/api/admin/categories', {
    method: 'POST',
    body: JSON.stringify({ hub, ...payload }),
  });
}

export async function updateCategory(hub, id, payload) {
  return apiFetch(`/api/admin/categories/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteCategory(hub, id) {
  return apiFetch(`/api/admin/categories/${id}`, { method: 'DELETE' });
}

// ── Products ──

export async function getProducts(hub) {
  return apiFetch(`/api/admin/products/${hub}`);
}

export async function createProduct(hub, payload) {
  return apiFetch(`/api/admin/products/${hub}`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateProduct(hub, id, payload) {
  return apiFetch(`/api/admin/products/${hub}/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteProduct(hub, id) {
  return apiFetch(`/api/admin/products/${hub}/${id}`, { method: 'DELETE' });
}

// ── Digital Invitations ──

export async function getDigitalInvitations() {
  return apiFetch('/api/admin/digital-invitations');
}

export async function getDigitalInvitation(id) {
  return apiFetch(`/api/admin/digital-invitations/${id}`);
}

export async function createDigitalInvitation(payload) {
  return apiFetch('/api/admin/digital-invitations', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateDigitalInvitation(id, payload) {
  return apiFetch(`/api/admin/digital-invitations/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteDigitalInvitation(id) {
  return apiFetch(`/api/admin/digital-invitations/${id}`, { method: 'DELETE' });
}

export function getDigitalInvitationQrUrl(slug) {
  const origin = window.location.origin;
  const publicUrl = process.env.PUBLIC_URL ?? '';
  return `${origin}${publicUrl}/${slug}`;
}

// ── Settings ──

export async function getSettings() {
  return apiFetch('/api/admin/settings');
}

export async function updateSettings(payload) {
  return apiFetch('/api/admin/settings', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

// ── Media ──

export async function uploadMedia(file) {
  const form = new FormData();
  form.append('file', file);
  const token = getToken();
  const res = await fetch(`${API_BASE}/api/admin/media/upload`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Yükleme başarısız');
  }
  return res.json();
}